import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
// 引入echarts
import echarts from 'echarts';
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
/*引入axios*/
import axios from 'axios';
import 'default-passive-events';
import store from './store/store';
import vueToPdf from 'vue-to-pdf';
import { verifyUrl } from './utils/verify';
import QuitOperation from './utils/quitOperation';
import { parseQuery } from './utils/parsing';
import { getLogo } from './api/login';
import { getUniCode } from './api/sassApi';
import dataV from '@jiaminghi/data-view'
import VScaleScreen from 'v-scale-screen'
import china from 'echarts/map/json/china.json' //导入china包
import 'echarts-wordcloud/dist/echarts-wordcloud.min'
echarts.registerMap('china', china)
Vue.prototype.$echarts = echarts
Vue.use(VScaleScreen)

Vue.use(dataV)
Vue.use(QuitOperation);
Vue.use(vueToPdf);


Vue.use(Avue);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});


import { Message } from 'element-ui';
//定义一个新的Message方法，多传入一个offset参数
const $message = options => {
    return Message({
        ...options,
        offset: 400,    //消息距离顶部的距离
        showClose:true, //是否显示关闭按钮
    });
};

//重写方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
    $message[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options,
                offset: 400,
                showClose:true,
            };
        }
        options.type = type;
        return Message(options);
    };
});
//将$message挂载到this上
Vue.prototype.$message = $message;
//不加这行代码运行this.$message.closeAll时会报错
Vue.prototype.$message.closeAll = Message.closeAll;

//引入axios
Vue.prototype.$axios = axios;
axios.defaults.baseURL = 'http://ceshi.subaoquan.com/';
axios.interceptors.request.use((config) => {
    config.headers.token = localStorage.getItem('token');
    ;
    return config;
});


axios.interceptors.response.use((config) => {
    if (config.data.code == 455) {
        ElementUI.Message({
            message: config.data.msg,
            type: 'error'
        });
        return;
    }
    if (config.data.code > 450 && config.data.code < 460) {
        ElementUI.Message({
            message: config.data.msg,
            type: 'error'
        });
        window.localStorage.clear();
        router.push('/login');
    }
    return config;
});

// router.beforeEach((to,from,next)=>{
//     if(to.path == "/login"){
//         return next();
//     }
//     const token = window.localStorage.getItem("token");
//     //本地获取token，如果没有就返回登录页面
//     if(token==null || token == undefined){
//         return next('/login');
//     }
//     next();
// });


//使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
//     document.title = `${to.meta.title} | vue-manage-system`;
//     const role = localStorage.getItem('ms_username');
//     if (!role && to.path !== '/login') {
//         next('/login');
//     } else if (to.meta.permission) {
//         // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
//         role === 'admin' ? next() : next('/403');
//     } else {
//         // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
//         if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
//             Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
//                 confirmButtonText: '确定'
//             });
//         } else {
//             next();
//         }
//     }
// });
//守卫路由代码
// 导航守卫限制路由跳转
router.beforeEach((to, from, next) => {
    verifyUrl();
    //获取地址栏参数确定对应logo
    let { qiye, promotion_code } = parseQuery();
    if (!qiye) {
        qiye = 0;
    }
    if (promotion_code){
        sessionStorage.setItem('promotion_code', promotion_code);
    }

    if (!localStorage.getItem('logo')) {
        getLogo({ qiye: qiye }).then(res => {
            if (res.code == 200) {
                localStorage.setItem('logo', JSON.stringify(res.data.logo_url));
            } else {
                this.$message.error(res.msg);
            }
        });
    }

    // if (localStorage.getItem('logo'))
    let userData = localStorage.getItem('userData');
    if (!userData) {
        if (process.env.VUE_APP_BASE_API == window.location.origin || process.env.NODE_ENV != 'production') {
            let { mark } = parseQuery();
            if (mark != undefined) {
                mark = mark.replace('#/', '');
            }
            let data = {
                category: mark != undefined ? 2 : 1,
                category_mark: mark != undefined ? mark : window.location.host
            };
            getUniCode(data).then(res => {
                if (res.code == 200) {
                    localStorage.setItem('userData', JSON.stringify(res.data));
                    next({ path: '/login' });
                } else {
                    ElementUI.Message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        } else {
            let data = {
                category: 1,
                category_mark: window.location.host
            };
            getUniCode(data).then(res => {
                if (res.code == 200) {
                    localStorage.setItem('userData', JSON.stringify(res.data));
                    next({ path: '/login' });
                } else {
                    ElementUI.Message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        }

        // let { mark } = parseQuery();
        // //如果地址栏有mark参数就传递平台类型为2账户型
        // if (mark != undefined) {
        //     let data = {
        //         category: 2,
        //         category_mark: mark
        //     };
        //     getUniCode(data).then(res => {
        //         if (res.code == 200) {
        //             localStorage.setItem('userData', JSON.stringify(res.data));
        //             next({ path: '/login' });
        //         } else {
        //             ElementUI.Message({
        //                 message: res.msg,
        //                 type: 'error'
        //             });
        //         }
        //     });
        // } else {
        //     let data = {
        //         category: 1,
        //         category_mark: window.location.host
        //     };
        //     getUniCode(data).then(res => {
        //         if (res.code == 200) {
        //             localStorage.setItem('userData', JSON.stringify(res.data));
        //             next({ path: '/login' });
        //         } else {
        //             ElementUI.Message({
        //                 message: res.msg,
        //                 type: 'error'
        //             });
        //         }
        //     });
        // }
    } else {
        let token = sessionStorage.getItem('token');
        if (!token) {
            if (to.path === '/forget' || to.path === '/registered' || to.path === '/noLanding') {
                next();
            } else if (to.path !== '/login') {
                setTimeout(() => {
                    next({ path: '/login' });
                }, 500);
            } else {
                setTimeout(() => {
                    next();
                }, 500);
            }
        } else {
            if (to.path == '/basicInformation') {
                if (window.location.search && process.env.NODE_ENV == 'production') {
                    window.location.href = '/client/#/basicInformation' + window.location.search;
                    return;
                }
            }
            if (to.path == '/basicInformationpay') {
                if (window.location.search && process.env.NODE_ENV == 'production') {
                    window.location.href = '/client/#/basicInformationpay' + window.location.search;
                    return;
                }
            }
            next();
        }
    }
    //如果有token的话说明你已经登录,让你正常登录
    // if (token) {
    //     next();
    // } else {
    //     //如果没有登录你访问的不是login就让你强制跳转到login页面
    //     if (to.path !== "/login") {
    //         next({ path: "/login" });
    //     } else {
    //         next();
    //     }
    // }
});
// router  要跟你引用的路由名称一致


new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');
